import { render, staticRenderFns } from "./EncabezadoDocente.vue?vue&type=template&id=7ae32309&"
import script from "./EncabezadoDocente.vue?vue&type=script&lang=js&"
export * from "./EncabezadoDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports